export default function RestUtils(Authentication, Restangular, Timezones) {
  'ngInject';

  const service = this;

  service.timezonesCached = null;
  service.geoCached = null;

  service.getTimezones = async function getTimezones() {
    if (!service.timezonesCached) {
      service.timezonesCached = (await Timezones.getList()).map((tz) => ({
        label: tz.displayname,
        value: tz.zone,
      }));
    }

    return service.timezonesCached;
  };

  service.getDefaultTimezones = function getDefaultTimezones({ timezone } = Authentication.user) {
    if (service.timezonesCached) {
      // we have real timezones already fetched
      return service.timezonesCached;
    }

    return [
      {
        label: timezone,
        value: timezone,
      },
      // fake timezone to show 'loading...' right in the <select> element
      {
        label: 'loading...',
        value: null,
        disabled: true,
      },
    ];
  };

  service.getGeo = function getGeo() {
    if (!service.geoCached) {
      service.geoCached = Restangular.one('geo').get();
    }

    return service.geoCached;
  };
}
